/*
  INSERT INTO _60rs (
    _dmn, 
    _key, _vsn, _ltt, _fst, 
    _icn, 
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    0, 
    1, 1, 1, 1, 
    '2022', 
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );

  INSERT INTO _601s (
    _dmn, 
    _key, _vsn, _ltt, _fst, 
    _601_60r1k, _icn, 
    _who, _dtm, "createdAt", "updatedAt")
  VALUES (
    0, 
    1, 1, 1, 1, 
    1, '2022-11-23',
    -1, '2000-01-01 00:00:00', '2000-01-01 00:00:00', '2000-01-01 00:00:00'
  );

*/

import * as _hm from './_hf';
import * as _hmFTH from './_hmFTH';
import * as _ht from './_ht';

export const grtPzForLoad_601Ps = (uz: _ht.uz, pz?: {
  dates?: _ht.ls,
  yearMth?: _ht.s,
  dateStt?: _ht.s,
  dateEnd?: _ht.s,
} ) => {
  let _cdn = _hmFTH.vdd(uz, { bVsn: true, bDmn: false });
  if (pz?.dates) _cdn += ` AND _icn IN (${_hm.join(pz.dates, ',', `'`)})`;
  if (pz?.yearMth) _cdn += ` AND _icn LIKE '${pz.yearMth}%'`;
  if (pz?.dateStt) _cdn += ` AND _icn >= '${pz.dateStt}'`;
  if (pz?.dateEnd) _cdn += ` AND _icn <= '${pz.dateEnd}'`;
  //hf.l(`_cv_61_Mz 47: ${_cdn}`);
  return {
    tgt: '_601s',
    cdn: _cdn,
    fld: '_icn',
  };
};

export const _60z = { // 祝日（ドメイン共通）
  _60r: { // 年
    v0: {
      itlz: {
        _icn: '',
      },
      fldz: {
        _icn: {
          pfx: '年'
        }
      },
    },
  },
  _601: { // 休日
    v0: {
      itlz: {
        _601_60r1k: -1,
        _icn: '',
      },
      fldz: {
        _601_60r1k: {
          pfx: '年'
        },
        _icn: {
          pfx: '日付',
        },
      },
    },
  },
};
